module.exports = __webpack_public_path__ + "static/media/idbormReactTodoIntro.f2ee8f19.png";